import browser from "webextension-polyfill";
import { alarmName, intervalKey, lastPingKey, PartnerExtensionIds, PingMessage, } from "./detection.types.js";
export async function sendPingToParterExtension() {
    const promises = [];
    const foundExtensionIds = [];
    for (const extensionId of PartnerExtensionIds) {
        const response = browser.runtime
            .sendMessage(extensionId, PingMessage, undefined)
            .then((result) => {
            const pingResult = result;
            if (pingResult === null || pingResult === void 0 ? void 0 : pingResult.pingResponse) {
                foundExtensionIds.push(extensionId);
            }
            return !!(pingResult === null || pingResult === void 0 ? void 0 : pingResult.pingResponse);
        })
            .catch(() => {
            return false;
        });
        promises.push(response);
    }
    await Promise.all(promises);
    return foundExtensionIds;
}
export async function sendSavePingResponses(parameters) {
    await (parameters === null || parameters === void 0 ? void 0 : parameters.prefs.untilLoaded);
    const lastPingTimestamp = parameters === null || parameters === void 0 ? void 0 : parameters.prefs.get(lastPingKey);
    const intervalTime = parameters === null || parameters === void 0 ? void 0 : parameters.prefs.get(intervalKey);
    if (Date.now() - lastPingTimestamp < intervalTime) {
        parameters === null || parameters === void 0 ? void 0 : parameters.logger.debug("[conflict-detection]: Ping time too early, not pinging.");
        return;
    }
    parameters === null || parameters === void 0 ? void 0 : parameters.logger.debug("[conflict-detection]: pinging.");
    const foundExtensionIds = await sendPingToParterExtension();
    await parameters.onUpdatedPartnerExtensionIds(foundExtensionIds);
    await (parameters === null || parameters === void 0 ? void 0 : parameters.prefs.set(lastPingKey, Date.now()));
    parameters === null || parameters === void 0 ? void 0 : parameters.logger.debug(`[conflict-detection]: foundExtensionIds : ${foundExtensionIds.toString()}`);
}
export async function addAlarmListener(parameters) {
    browser.alarms.onAlarm.addListener((alarm) => {
        if (alarm.name !== alarmName) {
            return;
        }
        void sendSavePingResponses(parameters);
    });
}
function addMessageListener() {
    browser.runtime.onMessageExternal.addListener(function (message, sender, sendResponse) {
        if (!isMessage(message) || !isKnownSender(sender)) {
            return;
        }
        sendResponse({ pingResponse: true });
        return true;
    });
}
export async function start(parameters) {
    void addAlarmListener(parameters);
    addMessageListener();
    await (parameters === null || parameters === void 0 ? void 0 : parameters.prefs.untilLoaded);
    const intervalTime = parameters.prefs.get(intervalKey);
    if (typeof intervalTime !== "number") {
        parameters === null || parameters === void 0 ? void 0 : parameters.logger.debug("[conflict-detection]: no intervalKey found in Prefs");
        return;
    }
    const partnerAlarm = await browser.alarms.get(alarmName);
    if (partnerAlarm) {
        parameters === null || parameters === void 0 ? void 0 : parameters.logger.debug(`[conflict-detection]: alarm found, scheduled for ${new Date(partnerAlarm.scheduledTime).toLocaleString()}`);
        return;
    }
    browser.alarms.create(alarmName, {
        periodInMinutes: intervalTime / 1000 / 60,
    });
    void sendSavePingResponses(parameters);
}
function isMessage(candidate) {
    return (candidate !== null && typeof candidate === "object" && "type" in candidate);
}
function isKnownSender(sender) {
    return (typeof (sender === null || sender === void 0 ? void 0 : sender.id) === "string" &&
        PartnerExtensionIds.includes(sender.id));
}
